// Add payment routes to whitelist
export const checkAuth = () => {
    const isLoggedIn = localStorage.getItem('token') // 示例：从本地存储获取 token
    return !!isLoggedIn // 返回布尔值表示是否已登录
}

const whiteList = [
  '/login',
  '/register',
  '/payment/unified/pay',
  '/payment/qrcode/innercode',
  '/payment/qrcode/lanecode',
  '/payment/qrcode/rs-record',
  '/h5/rsparking-record',
  '/h5/rsparking-merge',
  '/payment/confirm',
  '/payment/parking-details',
  '/payment/sub-orders',
  '/payment/success',
  '/parking/monthly-card/quick-renewal',
  '/redemption',
  '/transfer'
];

export const setupGuards = (router) => {
    router.beforeEach((to, from, next) => {
        // History mode: if the URL was opened with hash (e.g. old QR: .../#/parking/monthly-card/quick-renewal),
        // the router sees path "/". Redirect to the hash path so the correct page loads.
        if (to.path === '/' && typeof window !== 'undefined' && window.location.hash) {
            const hash = window.location.hash;
            if (hash.startsWith('#/')) {
                const fullPath = hash.slice(1);
                next(fullPath);
                return;
            }
        }

        console.log('[路由守卫] 访问路径:', to.path);

        // 检查白名单（支持前缀匹配）
        const isInWhiteList = whiteList.some(path => {
            // 移除末尾斜杠和通配符，支持带参数路径
            const basePath = path.replace(/\/\*?$/, '');
            return to.path.startsWith(basePath);
        });

        // 检查路由元标记
        const requiresNoAuth = to.matched.some(record => record.meta.noAuth);

        // 调试输出
        console.log('[路由守卫] 访问路径:', to.path);
        console.log('[白名单匹配]:', isInWhiteList);
        console.log('[无需认证标记]:', requiresNoAuth);

        // 放行条件：在白名单或标记无需认证
        if (isInWhiteList || requiresNoAuth) {
            next();
            return;
        }

        // 检查是否已登录
        if (checkAuth()) {  // Fixed: Call the function to get boolean result
            next();
        } else {
            // 重定向到登录页
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    });
}
 